var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jdh-height-transition',[_c('div',{staticClass:"jdsc-workbench-toolbar"},[_c('div',[_c('jds-toolbar',[_vm._t("left")],2)],1),_c('div',[_c('jds-toolbar',[_vm._t("right")],2)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }